import { gql } from "@apollo/client";

const DISABLE_RENEW_SUBSCRIPTION = gql`
  mutation DisableRenewSubscription {
    disableSubscriptionRenew {
      subscription {
        id
        status
        renew
      }
    }
  }
`;

export default DISABLE_RENEW_SUBSCRIPTION;
